import React, { useCallback, useRef } from 'react';
import { graphql, useMutation, usePreloadedQuery } from 'react-relay/hooks';
import { FormModal } from '@sonika-se/ui-kit/components';
import AssetAddressForm from '~/forms/AssetAddressForm';
export const assetAssetUpdateModalQuery = graphql `
  query AssetAddressUpdateModalQuery($assetId: ID!) {
    asset(id: $assetId) {
      city
      id
      postalCode
      street
    }
  }
`;
export const AssetAddressUpdateModal = (props) => {
    const { onClose, preloadedQuery } = props;
    const { asset } = usePreloadedQuery(assetAssetUpdateModalQuery, preloadedQuery);
    const [updateAsset, updateAssetLoading] = useMutation(graphql `
      mutation AssetAddressUpdateModal_updateAssetMutation($model: UpdateAssetRequestInput!) {
        updateAsset(model: $model) {
          assetEdge {
            node {
              city
              postalCode
              street
            }
          }
        }
      }
    `);
    const formRef = useRef(null);
    const handleSubmit = useCallback((form) => {
        updateAsset({
            onCompleted: () => {
                onClose();
            },
            variables: {
                model: {
                    id: asset.id,
                    city: form.city,
                    postalCode: form.postalCode,
                    street: form.street,
                },
            },
        });
    }, []);
    return (<FormModal onClose={() => onClose()} onSubmit={() => formRef.current.submit(handleSubmit)} submitButtonLabel="Spara" disabled={updateAssetLoading} title="Ändra adress">
      <AssetAddressForm disabled={updateAssetLoading} defaultValues={{
            city: asset.city,
            postalCode: asset.postalCode,
            street: asset.street,
        }} onSubmit={handleSubmit} ref={formRef}/>
    </FormModal>);
};
export default AssetAddressUpdateModal;
